import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=351648f6"
import script from "./my-account.js?vue&type=script&lang=js&external"
export * from "./my-account.js?vue&type=script&lang=js&external"
import style0 from "./my-account.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports